// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".asset-management_container__2p3xA{\n    display: flex;\n    flex-direction: column;\n    margin: 12px;\n    height: 100%;\n}\n\n.asset-management_list__2XxaA{\n    flex-grow: 4;\n}\n.asset-management_actions__SwHCR{\n    flex-grow: 1;\n}\n", "",{"version":3,"sources":["webpack://src/pages/asset-management/asset-management.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".container{\n    display: flex;\n    flex-direction: column;\n    margin: 12px;\n    height: 100%;\n}\n\n.list{\n    flex-grow: 4;\n}\n.actions{\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "asset-management_container__2p3xA",
	"list": "asset-management_list__2XxaA",
	"actions": "asset-management_actions__SwHCR"
};
export default ___CSS_LOADER_EXPORT___;
